/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_PendingInputs */

const en_invoice_request_pending = /** @type {(inputs: Invoice_Request_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice requested`)
};

const pl_invoice_request_pending = /** @type {(inputs: Invoice_Request_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktura zamówiona`)
};

/**
* | output |
* | --- |
* | "Invoice requested" |
*
* @param {Invoice_Request_PendingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_pending = /** @type {((inputs?: Invoice_Request_PendingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_PendingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_pending(inputs)
	return en_invoice_request_pending(inputs)
});